import { defineMessages } from 'react-intl';

export const chatEmptyStateMessages = defineMessages({
  lookingUp: {
    defaultMessage:
      '{hasName, select, true {What are we looking up today, {name}?} other {What are we looking up today?}}', id: '9SRf2HVRl8',
    description:
      'Random empty-state greeting when starting a new Evidence chat. `{name}` is the user’s first name in Western locales, or family name in ja/ko/zh locales.',
  },
  workingUp: {
    defaultMessage:
      '{hasName, select, true {What are we working up today, {name}?} other {What are we working up today?}}', id: 'YprQ0POr7N',
    description:
      'Random empty-state greeting when starting a new Evidence chat. `{name}` is the user’s first name in Western locales, or family name in ja/ko/zh locales.',
  },
  treating: {
    defaultMessage:
      '{hasName, select, true {What are we treating today, {name}?} other {What are we treating today?}}', id: 'Uh2bFC2Ml2',
    description:
      'Random empty-state greeting when starting a new Evidence chat. `{name}` is the user’s first name in Western locales, or family name in ja/ko/zh locales.',
  },
  trickyCase: {
    defaultMessage:
      '{hasName, select, true {Got a tricky case today, {name}?} other {Got a tricky case today?}}', id: 'U0pL0qINub',
    description:
      'Random empty-state greeting when starting a new Evidence chat. `{name}` is the user’s first name in Western locales, or family name in ja/ko/zh locales.',
  },
  checkSomething: {
    defaultMessage:
      '{hasName, select, true {Need to check something, {name}?} other {Need to check something?}}', id: 'v+STLuuPHt',
    description:
      'Random empty-state greeting when starting a new Evidence chat. `{name}` is the user’s first name in Western locales, or family name in ja/ko/zh locales.',
  },
  clinicalQuestion: {
    defaultMessage:
      '{hasName, select, true {What’s the clinical question today, {name}?} other {What’s the clinical question today?}}', id: 'Y0spXPjBPK',
    description:
      'Random empty-state greeting when starting a new Evidence chat. `{name}` is the user’s first name in Western locales, or family name in ja/ko/zh locales.',
  },
  whoAreWeSeeing: {
    defaultMessage:
      '{hasName, select, true {Who are we seeing today, {name}?} other {Who are we seeing today?}}', id: 'QdP3gKyHSt',
    description:
      'Random empty-state greeting when starting a new Evidence chat. `{name}` is the user’s first name in Western locales, or family name in ja/ko/zh locales.',
  },
  writeUp: {
    defaultMessage:
      '{hasName, select, true {Got something to write up, {name}?} other {Got something to write up?}}', id: 'dQFttWnktF',
    description:
      'Random empty-state greeting when starting a new Evidence chat. `{name}` is the user’s first name in Western locales, or family name in ja/ko/zh locales.',
  },
  questionBetweenPatients: {
    defaultMessage:
      '{hasName, select, true {Got a question between patients, {name}?} other {Got a question between patients?}}', id: 'rpMuKId0VS',
    description:
      'Random empty-state greeting when starting a new Evidence chat. `{name}` is the user’s first name in Western locales, or family name in ja/ko/zh locales.',
  },
  secondOpinion: {
    defaultMessage:
      '{hasName, select, true {Need a second opinion, {name}?} other {Need a second opinion?}}', id: 'n/BcRrtG1+',
    description:
      'Random empty-state greeting when starting a new Evidence chat. `{name}` is the user’s first name in Western locales, or family name in ja/ko/zh locales.',
  },
  howCanIHelp: {
    defaultMessage:
      '{hasName, select, true {How can I help today, {name}?} other {How can I help today?}}', id: '22pv2EdYke',
    description:
      'Random empty-state greeting when starting a new Evidence chat. `{name}` is the user’s first name in Western locales, or family name in ja/ko/zh locales.',
  },
  doubleCheck: {
    defaultMessage:
      '{hasName, select, true {Want to double-check something, {name}?} other {Want to double-check something?}}', id: 'mmMDMr5Ymz',
    description:
      'Random empty-state greeting when starting a new Evidence chat. `{name}` is the user’s first name in Western locales, or family name in ja/ko/zh locales.',
  },
});

export const CHAT_EMPTY_STATE_GREETING_KEYS = [
  'lookingUp',
  'workingUp',
  'treating',
  'trickyCase',
  'checkSomething',
  'clinicalQuestion',
  'whoAreWeSeeing',
  'writeUp',
  'questionBetweenPatients',
  'secondOpinion',
  'howCanIHelp',
  'doubleCheck',
] as const satisfies ReadonlyArray<keyof typeof chatEmptyStateMessages>;
